<template>
  <v-card class="cursor-pointer" @click="$emit('selected', customer.id)">
    <v-row>
      <v-col cols="12" sm="10">
        <div class="font-weight-bold text-subtitle-1">
          {{ customer.firstname }} {{ customer.lastname }}
        </div>
        <div>{{ customer.email }} {{ customer.phone }}</div></v-col
      >
      <v-col cols="12" sm="2">
        <v-btn
          variant="tonal"
          min-width="36"
          @click.stop.prevent="goToEditPage(customer.id)"
        >
          <v-icon>mdi-file-edit</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
  <!-- Render Notes Below -->
  <render-notes
    v-if="showNotes"
    :customer="customer"
    @toggle-addnote="$emit('toggle-addnote', customer.id)"
  ></render-notes>
</template>

<script>
import RenderNotes from "./Notes/RenderNotes.vue";
export default {
  name: "ListCustomer",
  components: {
    RenderNotes,
  },
  props: {
    customer: {
      type: Object,
      required: true,
    },
    showNotes: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["selected", "toggle-addnote"],
  setup() {
    const apiURL = import.meta.env.VITE_API_URL;
    return { apiURL };
  },
  data() {
    return {
      show_notes: this.selectedItem === this.customer.id,
    };
  },
  methods: {
    goToEditPage(id) {
      window.location.href = `/merge/${id}/edit`;
    },
  },
};
</script>
